import { useNavigate } from 'react-router-dom';

function Setup(){
    const navigate = useNavigate();

    const goToAdmin = () => navigate('/admin');

    return (<>
        <div style={{maxWidth:'800px', margin:'40px auto', padding:'24px'}}>
            <h1>Welcome to BDSA</h1>
            <p style={{fontSize:'1.1rem', lineHeight:'1.6'}}>
                This BDSA deployment needs to be set up before it can be used.
            </p>
            <p style={{fontSize:'1.05rem', lineHeight:'1.6'}}>
                An administrator login is required to proceed. If this is a fresh deployment, you may need to use the default DSA administrator credentials unless they have already been changed.
            </p>
            <p style={{marginTop:'12px'}}>
                You can also open the DSA application at <a href="/dsa">/dsa</a>.
            </p>
            <div style={{marginTop:'24px'}}>
                <button onClick={goToAdmin} style={{
                    padding:'12px 20px',
                    fontSize:'1rem',
                    fontWeight:600,
                    background:'#1f6feb',
                    color:'#fff',
                    border:'none',
                    borderRadius:'6px',
                    cursor:'pointer'
                }}>Get Started</button>
            </div>
        </div>
    </>);
}

export default Setup;
